module.exports = __webpack_public_path__ + "static/media/RRD3-BG4.dddf76d2.jpg";